module.exports = __webpack_public_path__ + "img/2e206fb.png";